import { Alert, Badge, Group, Paper, Stack, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../components/ui";
import { consultancyApi } from "../../lib/api";
import { formatDate } from "../../lib/format";
import { NAV_COPY, NAV_ICONS } from "../../lib/navCopy";

export function ConsultancyRateCardPage() {
  const rateCardQuery = useQuery({
    queryKey: ["consultancy-rate-card"],
    queryFn: consultancyApi.rateCard,
  });
  const card = rateCardQuery.data;

  return (
    <Stack gap="lg">
      <PageHeader
        icon={NAV_ICONS.rateCard}
        title={NAV_COPY.common.rateCard}
        subtitle="The split AxioHire applies when your recruiters make a placement. Contact your account manager to change it."
      />

      {rateCardQuery.isLoading ? (
        <Text c="dimmed">Loading…</Text>
      ) : !card ? (
        <Alert color="yellow" title="No active rate card">
          AxioHire has not set a standing split for this consultancy yet. Placements cannot pay out until one is active.
        </Alert>
      ) : (
        <Paper withBorder p="lg">
          <Group justify="space-between" mb="md">
            <div>
              <Text fw="var(--axio-font-weight-bold)" size="lg">
                {card.name}
              </Text>
              <Text size="sm" c="dimmed">
                Effective {formatDate(card.effective_from)}
                {card.effective_to ? ` – ${formatDate(card.effective_to)}` : ""}
              </Text>
            </div>
            <Badge variant="light" color={card.status === "active" ? "teal" : "gray"}>
              {card.status}
            </Badge>
          </Group>
          <Group gap="lg">
            <SplitStat label="Consultancy" value={card.recruiter_fee_pct} color="violet" />
            <SplitStat label="Sourcing" value={card.sourcing_fee_pct} color="teal" />
            <SplitStat label="Platform" value={card.platform_fee_pct} color="gray" />
          </Group>
          {card.notes && (
            <Text size="sm" c="dimmed" mt="md">
              {card.notes}
            </Text>
          )}
        </Paper>
      )}
    </Stack>
  );
}

function SplitStat({ label, value, color }: { label: string; value: number; color: string }) {
  return (
    <Stack gap="var(--axio-unit-2)">
      <Text size="xs" c="dimmed" tt="uppercase" fw="var(--axio-font-weight-bold)">
        {label}
      </Text>
      <Badge size="lg" variant="outline" color={color}>
        {value}%
      </Badge>
    </Stack>
  );
}
